import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a508c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"150px"}
}
const _hoisted_2 = { key: 1 }

import { onMounted, ref, withDefaults, watch } from "vue";
import { useAuth } from "@/composables/useAuth";
import { UsuarioViewDTO } from "@/interfaces/Usuario";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { useUsuariosStore } from "@/store/usuarios";
import CardPerfilUsuario from "@/components/Perfil/CardPerfilUsuario.vue";
import SparklineElo from "@/components/Elo/SparklineElo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PerfilUsuarioView',
  props: {
    editable: { type: Boolean, default: true },
    email: { default: "" }
  },
  setup(__props: any) {

const usuariosStore = useUsuariosStore();

const isLoading = ref(true);
const { getUser } = useAuth();
const correo = ref<string>(getUser.value);
const selectedFaccionName = ref<number>(0);
const user = ref<UsuarioViewDTO>();

const props = __props;

// Función para cargar los datos del usuario
const cargarUsuario = async () => {
  try {
    isLoading.value = true;
    if (props.email == "") {
      await usuariosStore.requestUsuario(correo.value);
    } else {
      await usuariosStore.requestUsuario(props.email);
    }
    user.value = usuariosStore.usuario; // ✅ Asegura que user tiene datos antes de renderizar
    selectedFaccionName.value = user.value.idFaccion || 0;
  } catch (error) {
    console.error("Error al obtener el usuario:", error);
  } finally {
    isLoading.value = false;
  }
};

// Ejecutar cuando el componente se monta
onMounted(() => {
  if (correo.value) {
    cargarUsuario();
  }
});

// Observar cambios en la prop `email` y recargar datos
watch(
  () => props.email,
  async (newEmail, oldEmail) => {
    if (newEmail && newEmail !== oldEmail) {
      await cargarUsuario();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingGandalf)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_v_container, { class: "profile-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CardPerfilUsuario, {
                      user: user.value!,
                      selectedFaccionName: selectedFaccionName.value,
                      editable: _ctx.editable
                    }, null, 8, ["user", "selectedFaccionName", "editable"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SparklineElo, {
                      idUsuario: user.value?.idUsuario!
                    }, null, 8, ["idUsuario"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
}
}

})